import LinearGaugeView from './linear-gauge-view'
import _ from 'lodash'
import allowThresholdLabels from './allow-threshold-labels'
import BaseGaugeModel from '../base-gauge-model'

var LinearGauge = BaseGaugeModel.extend({

	// If these change, update WIDGET_DIMENSIONS in DashboardBuilder.kit
	containerDefaults: {
		height: 80,
		width: 365,
		minWidth: 30
		// Note: see LinearGaugeView.initialize() for the minHeight function
	},

	viewCls: LinearGaugeView,

	type: 'linear-gauge',

	gaugeOptions: function({ datasetQueryResponse } = {}) {
		var props = _.cloneDeep(this.properties.attributes)
		var data = this.relevantData()

		let baseOptions = BaseGaugeModel.prototype.gaugeOptions.apply(this, arguments)
		let opt = _.extend(props, baseOptions,{
			model: data.scorecardNode
		})

		opt.gaugeHeight = parseFloat(opt.gaugeHeight)
		opt.width = this.wob.get('width')
		opt.height = this.wob.get('height')
		opt.thresholds = props.showThresholds
		opt.pointerLabel = props.showPointerLabel
		opt.fontSize = props.fontSize
		// most of this.relevantData() should be relevant, so let's use it
		// as defaults for the options
		opt = _.defaults(opt, data)
		// #58726 the dataType in particular needs to come from data.dataType
		opt.dataType = data.dataType
		// `opt` originally starts from `props`, which could have `periodId: null`
		// if it was configured to be a relative period. But `data` has the
		// resolved `periodId` we need, so make sure we use that
		opt.periodId = data.periodId

		if (!props.showPrevious) {
			opt.previousScore = undefined
		}
		return opt
	},

	/**
	 * @override
	 */
	validShowProperties: function () {
		let props =
			BaseGaugeModel.prototype.validShowProperties.apply(this, arguments)

		if (!this.isNoneSource()) {
			// #60684 Always shows for linear gauges if there's a data source
			// this used to be called "Pointer Value" or "Pointer Score"
			props.push({
				property: 'showPointerLabel',
				label: 'dashboards.linear.pointerLabel.value'
			})
		}

		if (allowThresholdLabels(this.section(), this.scorecardItem())) {
			props.push({ property: 'showThresholds', label: 'scorecards.node.metric.thresholds' })
		}

		return props
	},

	multiSettableProps: function () {
		return _.map(this.validShowProperties(), 'property')
			.concat([ 'background', 'fontSize', 'calendarId', 'periodId',
				'periodDelta' ])
	}
})

export default LinearGauge

LinearGauge.__filename__ = 'dashboards/widgets/linear-gauge/linear-gauge-model.js'
